import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, roles, loading } = useAuth();

  if (loading) {
    return null; 
  }

  if(!user){
    return <Navigate to="/login" />; 
  }

  const hasRole = allowedRoles.some((role) => roles.includes(role));
  if(!hasRole){
    return <Navigate to="/" />; 
  }

  return children;
};

export default PrivateRoute;
